import { render } from "./ConsumptionsRegistration.vue?vue&type=template&id=7340b488"
import script from "./ConsumptionsRegistration.vue?vue&type=script&lang=js"
export * from "./ConsumptionsRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__